import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var EventManager = /*#__PURE__*/function () {
  function EventManager() {
    this.supposeCloud = void 0;
    this.taskCache = new Map();
  }
  var _proto = EventManager.prototype;
  _proto.register = function register(name, handler) {
    if (!EventManager.listener[name]) {
      EventManager.listener[name] = [];
    }
    EventManager.listener[name].push(handler);
  };
  _proto.unregister = function unregister(name, handler) {
    if (handler) {
      var listenerList = EventManager.listener[name];
      if (listenerList) {
        EventManager.listener[name] = listenerList.filter(function (item) {
          return item !== handler;
        });
      }
    } else {
      EventManager.listener[name] = [];
    }
  };
  _proto.broadcast = function broadcast(name, data) {
    var listeners = EventManager.listener[name];
    if (listeners) {
      for (var _iterator = _createForOfIteratorHelperLoose(listeners), _step; !(_step = _iterator()).done;) {
        var handler = _step.value;
        handler(data);
      }
    }
  };
  _proto.addTaskCache = function addTaskCache(taskID, content) {
    this.taskCache.set(taskID, content || true);
  };
  _proto.removeTaskCache = function removeTaskCache(taskID) {
    this.taskCache["delete"](taskID || '');
  };
  _proto.clearTaskCache = function clearTaskCache() {
    this.taskCache.clear();
  };
  _proto.getTaskCacheSize = function getTaskCacheSize() {
    return this.taskCache.size;
  };
  _proto.getTaskById = function getTaskById(taskID) {
    return this.taskCache.get(taskID || '');
  };
  _createClass(EventManager, null, [{
    key: "Instance",
    get: function get() {
      if (window.PRINT_EVENT_INSTANCE) {
        return window.PRINT_EVENT_INSTANCE;
      }
      window.PRINT_EVENT_INSTANCE = new EventManager();
      return window.PRINT_EVENT_INSTANCE;
    }
  }]);
  return EventManager;
}();
EventManager.listener = {};
export default EventManager;